import { createAsyncThunk, createSlice, } from '@reduxjs/toolkit'
import { AppState } from '@app/store/state/app.state';
import { Moment } from "moment";
import { selectOffices } from "./advanceHotDeskingSetup.duck";
import { CapacityResponse, getWeeklyOfficeCapacity } from '@features/desks/services/OfficeCapacityService';

export interface WeeklyDeskAvailability {
  requestingDate?: Moment;
  dailyAvailability: CapacityResponse[];
  loading: boolean;
}

export const initialWeeklyDeskAvailability: WeeklyDeskAvailability = {
  loading: false,
  dailyAvailability: [],
}


export const loadWeeklyAvailability: any = createAsyncThunk(
  'weeklyDeskAvailability/load',
  async (nothing: any, thunkAPI) => {
    const appState = thunkAPI.getState() as AppState;
    const offices = selectOffices(appState);

    const date = appState.dashboard.calendarDate;

    let availability: CapacityResponse[] = [];
    if (date && offices.length === 1) {
      const officeId = offices[0].id;
      const startOfWeek = date.clone().isoWeekday('monday');
      availability = await getWeeklyOfficeCapacity(officeId, startOfWeek);
    }

    return {
      requestingDate: date,
      dailyAvailability: availability,
      loading: false,
    }
  }
);
const weeklyDeskAvailabilitySlice = createSlice({
  name: 'weeklyDeskAvailability',
  initialState: initialWeeklyDeskAvailability,
  reducers: {
    reset: () => initialWeeklyDeskAvailability,
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadWeeklyAvailability.pending, (state) => ({...state, loading: true }))
      .addCase(loadWeeklyAvailability.rejected, (state) => ({...state, loading: false }))
      .addCase(loadWeeklyAvailability.fulfilled, (state, action) => ({...state, ...action.payload, loading: false }));
  }
});


export default weeklyDeskAvailabilitySlice.reducer;

export const selectWeeklyAvailability = (state: AppState) => state.weeklyDeskAvailability.dailyAvailability;
